import Button from 'components/base/Button';
import Rating from 'components/base/Rating';
import { Form, Modal } from 'react-bootstrap';
import Dropzone from 'components/base/Dropzone';
interface RequestClaimModalProps {
  show: boolean;
  id: number;
  status: string;
  handleClose: () => void;
  handleSubmit: (id: number, status: string) => void;
}

const RequestClaimModal = ({
  show,
  id,
  status,
  handleClose,
  handleSubmit
}: RequestClaimModalProps) => {
  const submit = () => {
    handleSubmit(id, status);
    handleClose();
  };

  const statusText = status === 'success' ? 'Approve' : 'Reject';

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title>Are you sure?</Modal.Title>
      </Modal.Header>
      <Modal.Body>{`Are you sure you want to ${statusText} this claim?`}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={submit}>
          Yes, {statusText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RequestClaimModal;
